export default {
  graphql_url: 'https://w0ansq5va5.execute-api.us-west-1.amazonaws.com/Prod/graphql',
  assman_token: '24C566553747F337185E0E890A385C13FBBBF491D3FADB7CBBCCA7C6ED6976E0EA55115FD4216298A76C9B5A022BFE2D4F0C81B939E7D4C26A558C6A6C1AA3C3'
}


// WEBPACK FOOTER //
// ./src/config.js